import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { login } from '../../utils/auth';
import Input from '../../components/base/Input';
import Button from '../../components/base/Button';

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Por favor, completa todos los campos');
      return;
    }

    const user = login(email, password);
    if (user) {
      navigate('/inicio');
    } else {
      setError('Credenciales incorrectas');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F7F9FC] to-white flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="w-20 h-20 bg-[#0A5FFF] rounded-full flex items-center justify-center mx-auto mb-4">
            <i className="ri-flashlight-fill text-white text-4xl"></i>
          </div>
          <h1 className="text-3xl font-bold text-[#1F2937] mb-2">Bienvenido</h1>
          <p className="text-gray-600">
            Accede a tu área personal para enviar facturas y hacer seguimiento
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                {error}
              </div>
            )}

            <Input
              type="email"
              label="Email o teléfono"
              placeholder="tu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <Input
              type="password"
              label="Contraseña"
              placeholder="••••••••"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <div className="text-right">
              <Link
                to="/recuperar-password"
                className="text-sm text-[#0A5FFF] hover:underline cursor-pointer"
              >
                ¿Olvidaste tu contraseña?
              </Link>
            </div>

            <Button type="submit" variant="primary" fullWidth>
              Iniciar sesión
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-gray-600">
              ¿No tienes cuenta?{' '}
              <Link
                to="/registro"
                className="text-[#0A5FFF] font-semibold hover:underline cursor-pointer"
              >
                Regístrate aquí
              </Link>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link
            to="/inicio"
            className="text-gray-600 hover:text-gray-900 cursor-pointer"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    </div>
  );
}
